import clsx from 'clsx';
import A from 'components/atoms/A/A';
import Txt from 'components/atoms/Txt/Txt';
import PageConfig from 'components/templates/Page/PageConfig';
import React from 'react';
import classes from './CashoutProviderButton.module.scss';
export interface Props {
  path: PageConfig['path'];
  Icon: any; // Use any to avoid conflicts with @svgr/webpack plugin or babel-plugin-inline-react-svg plugin.
  name: 'PayPal' | 'Venmo' | 'Gift Cards' | 'Charity';
  status: 'AVAILABLE' | 'OFFLINE' | 'REQUIRES_VERIFICATION';
  onLockedClick?: () => void;
}

const CashoutProviderButtonContent: React.FC<Pick<Props, 'Icon' | 'name'>> = ({ Icon, name }) => (
  <>
    <Icon className={classes.image} />
    <Txt component="h3">{name}</Txt>
  </>
);

const CashoutProviderButton: React.FC<Props> = ({ path, Icon, name, status, onLockedClick }) => {
  const locked = status !== 'AVAILABLE';
  const offline = status === 'OFFLINE';

  if (locked) {
    return (
      <button
        onClick={onLockedClick}
        className={clsx(classes.cashoutLink, offline && classes.offline)}
      >
        <CashoutProviderButtonContent Icon={Icon} name={name} />
      </button>
    );
  }

  return (
    <A to={path} className={classes.cashoutLink}>
      <CashoutProviderButtonContent Icon={Icon} name={name} />
    </A>
  );
};

export default CashoutProviderButton;
